import { normalizeSpeedLogo } from "components/ManageProduct/CreateProduct/ProductSKUCreate/helpers";
import type { CheckPriceCarrierItem } from "services/apiSpeedShipping";

/** ตัด _SPEED ออกจาก carrier/brand code — ให้ match partner_transport_brand */
export const stripSpeedCarrierCode = (code: string | null | undefined): string =>
  String(code ?? "").replace(/_SPEED/gi, "").trim();

/** รหัสขนส่งสำหรับ createShipment — ใช้เฉพาะ carrier_code (ห้าม fallback เป็น carrier ที่เป็นชื่อย่อ) */
export const getCheckPriceCarrierCode = (item: CheckPriceCarrierItem): string =>
  String(item.carrier_code ?? "").trim();

export const carrierCodesMatch = (
  a: string | null | undefined,
  b: string | null | undefined
): boolean => stripSpeedCarrierCode(a) === stripSpeedCarrierCode(b);

export { normalizeSpeedLogo };
